import { callApi } from 'utils/api';
import { policyModel, websiteModel } from 'common/api/models';
import { customFormFieldModel } from 'common/api/models/website';

/**
 * @return {Promise<{channels: Array, cssContent: Array|*|Function|channelsMock|{id}|{}, favicon: string, videosPerPage: number}>}
 */
export const fetchWebsiteApi = () => callApi('website').then((data) => websiteModel(data));

/**
 * @param {number} websiteId
 * @return {Promise<policyModel[]>}
 */
export const fetchPoliciesApi = (websiteId) =>
  callApi(`website/${websiteId}/policies`).then((policies) => policies.map(policyModel));

/**
 * @param {number} websiteId
 * @param {policyModel[]} policies
 * @return {Promise<policyModel[]>}
 */
export const updatePoliciesApi = (websiteId, policies) =>
  callApi(`website/${websiteId}/policies`, 'PUT', policies, true).then((policies) => policies.map(policyModel));

export const uploadFormConfigRequestApi = () =>
  callApi(`website/upload_config`)
    .then((customFormFields) => customFormFields.map(customFormFieldModel))
    // handle case when new field is created on BE but still not supported on FE
    .then((customFormFields) => customFormFields.filter((f) => f.type));
